import * as yup from 'yup';

const Schema = () =>
  yup.object().shape({
    email: yup.string().email().required('You must enter a email'),
    name: yup.string().required('You must enter a full name'),
    password: yup
      .string()
      .min(6, 'Must be more than 6 characters')
      .required('You must enter a password'),
  });

export default Schema;
